//import { EventBus, EventBusEvents } from '../utils/EventBus';
import { EventBusEventEnum } from '../enums/EventBusEventEnum';
import EventBus from '../services/EventBus';
import { getStorageItem } from '../utils/storage';
import { StorageItemKeyEnum } from '../enums/StorageItemKeyEnum';

export interface RequestHeaders {
  [header: string]: string;
}

export interface RequestBody {
  [key: string]: unknown;
}

export interface ErrorResponse extends Error {
  statusText: string;
  response?: Promise<unknown>;
  status: number;
}

class APIService {
  protected async request(
    endpoint: string,
    method: string,
    body?: RequestBody | string | FormData | unknown[],
    headers?: RequestHeaders,
    baseUrl: string = import.meta.env.VITE_APP_API_BASE_URL
  ) {
    const url = `${baseUrl}${endpoint}`;
    const urlWhiteList = [
      '/login',
      '/file/:id',
      '/file/protected/:fileId/:token',
      '/store/:fileId',
      '/payment/success/:fileId',
    ];

    const urlToRegex = (urlPattern: string) => {
      const regexString = urlPattern.replace(/:\w+/g, '[^/]+');
      return new RegExp(`^${regexString}$`);
    };

    const token = await getStorageItem(
      'localStorage',
      StorageItemKeyEnum.Token
    );

    const currentPath = window.location.pathname;
    const isWhitelisted = urlWhiteList.some((urlPattern) =>
      urlToRegex(urlPattern).test(currentPath)
    );

    if (!token && !isWhitelisted) {
      EventBus.emit(EventBusEventEnum.MakeLogout, {});
    }

    const headersInit: HeadersInit = {
      ...headers,
    };

    if (!(body instanceof FormData)) {
      headersInit['Content-Type'] = 'application/json';
    }

    if (token) {
      headersInit.Authorization = 'Bearer ' + token;
    }

    const options: RequestInit = {
      headers: headersInit,
      method,
    };

    if (body) {
      if (body instanceof FormData) {
        options.body = body;
      } else {
        options.body = JSON.stringify(body);
      }
    }

    return fetch(url, options).then(async (res) => {
      //EventBus.emit(EventBusEvents.API_REQUEST, { url });

      if (!res.ok) {
        if (
          res.status === 401 &&
          !urlWhiteList.includes(window.location.pathname)
        ) {
          EventBus.emit(EventBusEventEnum.MakeLogout, {});
        }

        const response = await res
          .text()
          .then((text) => (text ? JSON.parse(text) : {}));

        //EventBus.emit(EventBusEvents.UNAUTHORIZED_API_REQUEST, {});

        const error: ErrorResponse = new Error(res.statusText) as ErrorResponse;
        error.statusText = res.statusText;
        error.response = response;
        error.status = res.status;

        throw error;
      }

      const contentType = res.headers.get('content-type');

      if (contentType && contentType.indexOf('application/json') !== -1) {
        try {
          return await res
            .text()
            .then((text) => (text ? JSON.parse(text) : {}));
        } catch (error) {
          console.error('Error in parsing JSON', error);
          throw error;
        }
      } else {
        return res;
      }
    });
  }
}

export { APIService };
